import { CALL_HISTORY_METHOD } from 'react-router-redux';
import { browserHistory } from 'react-router';
import R from 'ramda';

import { checkLocAccess, triggerNoAccessWarning, getFeatureAccess } from './accessCheckHelperFns';

const controlledRouteChange = ({ dispatch, getState }) => next => action => {
  if (action && action.type !== CALL_HISTORY_METHOD) {
    return next(action);
  }

  const { payload: { method, args } } = action;
  if ((method === 'push' || method === 'replace')) {
    const route = args[0];
    const pathname = R.is(Object, route) ? route.pathname : route;
    // BEGIN ACCESS CHECK
    if (R.contains('/contracting', pathname)) {

      const access = getFeatureAccess(getState(), null, 'contracting');
      if (!R.contains('read', access)) return dispatch(triggerNoAccessWarning({ featureName: 'contracting' }));

      if (R.any(R.contains(R.__, pathname), [
        'mass-rate-change',
        'partners',
      ])) {
        const { contracting } = getState();
        const locationIdFromLeftNav = R.path(['leftNav', 'locationId'], contracting.contractActivitiesProducts.toJS());
        if (locationIdFromLeftNav && !checkLocAccess(getState(), locationIdFromLeftNav, 'contracting', 'write')) {
          return dispatch(triggerNoAccessWarning({ featureName: 'contracting' }));
        }
      }
    }

    if (R.contains('/integration/', pathname)) {
      const access = getFeatureAccess(getState(), null, 'contracting');
      if (!R.contains('write', access)) return dispatch(triggerNoAccessWarning({ featureName: 'contracting' }));
    }
    // END ACCESS CHECK
  }

  return browserHistory[method](...args);
};

export default controlledRouteChange;



// WEBPACK FOOTER //
// ./src/app/middleware/controlledRouteChange.js